// What a lazily-loaded page shows (aithlo-frontend#40): a quiet spinner while
// its chunk arrives, and — if the chunk can't be fetched (offline, or a deploy
// replaced the file the open tab asked for) — a sentence and a Reload button
// instead of a blank screen or a crash.
import React from 'react';
import { Button } from './ds';
import { Spinner, StatusPanel } from './auth/AuthLayout';

export default function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
      <Spinner size={24} />
      <span className="sr-only">Loading…</span>
    </div>
  );
}

export class RouteBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('Page failed to load:', error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    // Figma "Web · Page didn't load": the one-message state, inside the shell.
    return (
      <div role="alert" className="mx-auto flex min-h-[60vh] w-full max-w-[400px] items-center justify-center">
        <StatusPanel icon="x" title="This page didn’t load" body="Check your connection, then reload to try again.">
          <Button block onClick={() => window.location.reload()}>Reload</Button>
        </StatusPanel>
      </div>
    );
  }
}
